import { cn } from 'component-library';

import { TextAtomProps, TextContainer } from '@/components/widgets/a/Text/Text';

export const SectionHeader = ({ i18nPath, className, ...delegated }: TextAtomProps) => {
  return <TextContainer i18nPath={i18nPath} className={cn('typography-h4', className)} {...delegated} />;
};
